export function PostedPayoutService($http, apexApiUrl) {
    'ngInject'
    return {
        retrievePostedPayouts: retrievePostedPayouts,
        retrieveIcdPayouts: retrieveIcdPayouts,
        retrieveIcdPayout: retrieveIcdPayout,
        retrieveIcdPayoutHistory: retrieveIcdPayoutHistory,
        postPayouts: postPayouts,
        patchIcdPayout: patchIcdPayout,
        deleteIcdPayout: deleteIcdPayout
    };

    /**
     * Get a report of all posted payouts, consisting of the division and ICD payout amounts,
     * matching the given posted date in range and posted to the given division or corporation.
     * @param {any} startDate
     * @param {any} endDate
     * @param {any} divisionID
     * @param {any} icdCorporationID
     */
    function retrievePostedPayouts(startDate, endDate, divisionID, icdCorporationID) {
        const params = {};
        if (startDate) {
            params.startDate = kendo.format("{0:yyyy-MM-dd}", startDate);
        }
        if (endDate) {
            params.endDate = kendo.format("{0:yyyy-MM-dd}", endDate);
        }
        params.divisionID = divisionID;
        params.icdCorporationID = icdCorporationID;

        return $http({
            method: "GET",
            url: apexApiUrl + "posted-payouts",
            params: params,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Get the posted ICD payout amounts matching the given posted date in range and posted to
     * the given corporation or division.
     * @param {any} startDate
     * @param {any} endDate
     * @param {any} divisionID
     * @param {any} icdCorporationID
     */
    function retrieveIcdPayouts(startDate, endDate, divisionID, icdCorporationID) {
        const params = {};
        if (startDate) {
            params.startDate = kendo.format("{0:yyyy-MM-dd}", startDate);
        }
        if (endDate) {
            params.endDate = kendo.format("{0:yyyy-MM-dd}", endDate);
        }
        params.divisionID = divisionID;
        params.icdCorporationID = icdCorporationID;

        return $http({
            method: "GET",
            url: apexApiUrl + "posted-payouts/icd",
            params: params,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Get the posted ICD payout amounts with the given ID.
     * @param {any} icdPayoutID
     */
    function retrieveIcdPayout(icdPayoutID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "posted-payouts/icd/" + icdPayoutID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Get the full history of all posted ICD amounts for the payout with the given ID.
     * @param {any} icdPayoutID
     */
    function retrieveIcdPayoutHistory(icdPayoutID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "posted-payouts/icd/" + icdPayoutID + "/history",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Post the work order payouts matching the given query on the given posted date.
     * @param {any} postedDate
     * @param {any} query
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function postPayouts({ DivisionID, IcdCorporationID, ...request }) {
        return $http({
            method: "POST",
            url: apexApiUrl + "posted-payouts",
            params: {
                DivisionID,
                IcdCorporationID
            },
            data: request
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Update and adjust suggested rep payouts for the ICD payout with the given ID.
     * @param {any} icdPayoutID
     * @param {any} request A request consisting of work order payouts whose rep amounts should
     * be adjusted or overwritten.
     */
    function patchIcdPayout(icdPayoutID, request) {
        return $http({
            method: "PATCH",
            url: apexApiUrl + "posted-payouts/icd/" + icdPayoutID,
            data: request,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Hide the posted ICD payout with the given ID without deleting its history.
     * @param {any} icdPayoutID
     */
    function deleteIcdPayout(icdPayoutID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "posted-payouts/icd/" + icdPayoutID
        }).then(function (response) {
            return response.data;
        });
    }
}
